import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDocumentation } from '../../contexts/DocumentationContext';
import documentationData from '../../data/documentationData';

function DirectLinkHandler() {
  const { navigateToSection, navigateToSubsection } = useDocumentation();
  const location = useLocation();
  const processedInitialHash = useRef(false);
  
  useEffect(() => {
    // Process only once on initial load (either with hash or without)
    if (!processedInitialHash.current) {
      processedInitialHash.current = true;
      
      // If there's no hash, navigate to the first section by default
      if (!location.hash) {
        const firstSectionId = documentationData.sectionOrder[0]; // 'getting-started'
        navigateToSection(firstSectionId);
        return;
      }
      
      // Handle both old format (#section-subsection) and new format (#s=section&ss=subsection)
      if (location.hash.includes('=')) {
        // New format
        const params = new URLSearchParams(location.hash.substring(1));
        const section = params.get('s');
        const subsection = params.get('ss');
        
        if (section && documentationData.sections[section]) {
          if (subsection && documentationData.sections[section].subsections[subsection]) {
            navigateToSubsection(section, subsection);
          } else {
            navigateToSection(section);
          }
        }
      } else {
        // Legacy format support (#section-subsection)
        const hash = location.hash.substring(1);
        
        // First check if it's just a section
        if (documentationData.sections[hash]) {
          navigateToSection(hash);
          return;
        }
        
        // Then check if it's a section-subsection format
        for (const sectionId in documentationData.sections) {
          if (hash.startsWith(`${sectionId}-`)) {
            const subsectionId = hash.substring(sectionId.length + 1);
            if (documentationData.sections[sectionId].subsections[subsectionId]) {
              navigateToSubsection(sectionId, subsectionId);
              return;
            }
          }
        }
      }
    }
  }, [location.hash, navigateToSection, navigateToSubsection]);
  
  return null; // Purely functional component
}

export default DirectLinkHandler;